/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/** Supprime la virgule (et les espaces) en fin de chaîne retournée par l'API. */
const trimComma = (value?: string | null): string =>
  (value ?? "").replace(/,\s*$/, "").trim();

export default trimComma;
